import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import css from './index.css';
import TruckLoadRatio from '../common/loadRatio';
import AddressInformation from '../common/addressInformation';
import {removeRateCheck} from '~/modules/rate/actions';
import mapDispatch from '~/misc/mapDispatch';

class RateLoadRatio extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={cs(css.main)}>
        <div className={cs(css.loadRatioTitle)}>Truck to Load Ratio</div>
        <div className={cs(css.loadRatioContent)}>
          <AddressInformation
            pick={this.props.pick}
            drop={this.props.drop}
            equipment={this.props.equipment}
          />
          <div className={cs(css.loadRatioLable)}>
            <TruckLoadRatio
              optional='true'
              pick={this.props.pick}
              drop={this.props.drop}
              pickup={this.props.pickup}
              dropOff={this.props.dropOff}
              equipment={this.props.equipment}
            />
          </div>
        </div>
      </div>
    );
  }
  componentWillUnmount() {
    this.props.removeRateCheck();
  }
}
export default connect((state, {location: {query: {param}}}) => {
  const data = JSON.parse(param);
  const pickup = {
    lng: data.origin.lng,
    lat: data.origin.lat,
    city: data.origin.city,
    state: data.origin.state,
  };
  const dropOff = {
    lng: data.destination.lng,
    lat: data.destination.lat,
    city: data.destination.city,
    state: data.destination.state,
  };
  return {
    pick: data.origin.name,
    drop: data.destination.name,
    pickup: pickup,
    dropOff: dropOff,
    equipment: data.equipment,
  };
}, mapDispatch({
  removeRateCheck: (props) => removeRateCheck(),
}))(RateLoadRatio);



// WEBPACK FOOTER //
// ./src/components/rate/loadRatio/index.js